export default "__VITE_ASSET___jF9Z50C__"